module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f2b99ab8bc69d7ea36532138c98abfa7.gif";